// extracted by mini-css-extract-plugin
export default {"component":"Leaderboard_component__yhh+T"};